import App from '@/App.vue';
import '@/assets/styles.scss';
import { router } from '@/router';
import { createApp } from 'vue';
import { analytics } from './plugins/analytics.plugin';
import { mftp } from './plugins/mftp.plugin';
import { pinia } from './plugins/pinia';
import { i18n } from './plugins/vue-i18n';
import { vuetify } from './plugins/vuetify';

const app = createApp(App);
app.use(router);
app.use(pinia);
app.use(i18n);
app.use(vuetify);
app.use(analytics);
app.use(mftp);
app.mount('#app');
